import { Form } from "antd";
import { Checkbox } from "../../../BP2Components";
import React, { useState, useEffect } from "react";
import { useIntl } from "react-intl";
import {
   handleChangedRelatedField,
   handleGridTechname,
   renderDevInfo,
   handleFieldAlert,
} from "../../GeneralScripts";
import PropTypes from "prop-types";
import "./BoolField.less";
import FieldInfo from "../FieldInfo/FieldInfo";
import { useFormContext } from "../../../../context/FormContext/FormContext";
import { getAllFieldsWithAlerts, handleTemplateAlert } from "../../../../util/Scripts";

const BoolField = ({
   isRequired,
   element,
   form,
   isVisible,
   disabled,
   formId,
   insideGrid = false,
   rowDataId,
}) => {
   const intl = useIntl();
   const { getFieldDecorator } = form;
   const { formData, fieldsInfo, setFieldsInfo, changeFieldPendingStatus, fieldEnumMap } =
      useFormContext();
   const [infoText, setInfoText] = useState(null);

   const handleChange = (e) => {
      const currentForm = form?.getFieldsValue();
      form?.setFieldsValue({ ...currentForm, [element?.tech_name]: e.target.checked });
      const allFieldsWithAlerts = getAllFieldsWithAlerts(formData?.forms_data?.tab?.[0]?.elements);
      handleChangedRelatedField(
         element,
         form,
         setFieldsInfo,
         allFieldsWithAlerts,
         formId,
         intl,
         formData._formKey,
         rowDataId,
         changeFieldPendingStatus,
         fieldEnumMap,
      );
      element.hasAlert &&
         handleFieldAlert(
            element.id,
            element.tech_name,
            form,
            formData._formKey,
            setFieldsInfo,
            fieldEnumMap,
         );
   };
   const translatedLabel = element.label;

   const infoClass =
      fieldsInfo[element.tech_name] && fieldsInfo[element.tech_name] !== ""
         ? "bool-field-info"
         : "";

   useEffect(() => {
      const infoText = fieldsInfo[element.tech_name];
      setInfoText(infoText);
      handleTemplateAlert(element.tech_name, infoText);
   }, [fieldsInfo[element.tech_name]]);

   return (
      <Form.Item
         key={element.tech_name}
         label={!insideGrid && translatedLabel}
         className={`${element?.type}-field`}
         style={{
            display: !isVisible(element) && !window.devLogged ? "none" : "",
            gridArea: handleGridTechname(element.tech_name),
            opacity: isVisible(element) ? "1" : "0.5",
         }}
      >
         {getFieldDecorator(element.tech_name, {
            rules: [
               {
                  required: isRequired(element),
                  message: intl.formatMessage({ id: "field.required" }),
               },
            ],
            initialValue: element.value,
         })(
            <Checkbox
               onChange={(e) => handleChange(e)}
               defaultChecked={!!element.value && element.value !== "0"}
               disabled={disabled}
               className={`field_${element.tech_name} _id_${element.id}_id_ _type_${element?.type}_type_ ${infoClass} has-alert-${element.hasAlert}`}
            />,
         )}
         {renderDevInfo(element)}
         <FieldInfo text={infoText} />
      </Form.Item>
   );
};

BoolField.propTypes = {
   element: PropTypes.object.isRequired,
   disabled: PropTypes.bool,
   isVisible: PropTypes.func,
   form: PropTypes.any,
   formId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default BoolField;
